export const TEAK_TYPE_NAMES = {
	DESK: 'TeakTypeWorkplace',
	ROOM: 'TeakTypeMeetingRoom',
	PARKING: 'TeakTypeParkingSpace',
};
